import axios from "axios";
import {BASE_URL_GRAPH} from "../Config/globalParams";

// Récupérer l'accessToken de profil utilisateur
export const getAccessToken = (msalInstance,activeAccount) => {
  return new Promise((resolve) => {
        const accessTokenRequest = {
          account: activeAccount,
        };
        // Tenter de récupérer le token d'accès de manière silencieuse
        msalInstance
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            resolve(response.accessToken); // Résoudre avec le token d'accès
          })
          .catch((error) => {
            console.error(
              "Erreur lors de l'obtention du token d'accès :",
              error
            );
            resolve();
          });
      })
    
};


//récupérer la présence du profile
export const getProfilePresence = (accessToken) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL_GRAPH}/me/presence`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération de la présence :", error);
        resolve(); 
      });
  });
};

//les données du user
export const getUserData = (accessToken, userId) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL_GRAPH}/users/${userId}`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
  
          resolve(response.data); 
       
      })
      .catch((error) => {
        resolve(error);
      });
  });
};





